import { get } from 'lodash'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import TabsCartModal from '../../components/tabs/TabsCartModal'
import { hasCartItems } from '../../selectors/cart'
import { makeGetTabOrder } from '../../selectors/order'
import { startTabOrderAdjustment } from '../../actions/order'
import { removeFromCart } from '../../actions/cart'
import CartItemsViewModel from '../../viewmodels/CartItemsViewModel'
import { makeGetCartItems, getTotal, getCartQuantity2 } from '../../selectors/cart'
import { centsToDollars } from '../../utils/formatters'


const mapStateToProps = (state, ownProps) => {
  const orderId = get(ownProps, 'match.params.orderId', undefined)
  const getTabOrder = makeGetTabOrder(orderId)
  const order = getTabOrder(state, orderId)
  const isNewOrder = orderId === undefined || orderId === 'pay-now'
  const fetchedCartItems = makeGetCartItems()(state)
  const cartItems = CartItemsViewModel(fetchedCartItems)
  const orderTotal = order?.amountInCents ?? 0
  const total = centsToDollars(getTotal(state) + orderTotal)
  const itemCount = getCartQuantity2(state)

  return {
    hasCartItems: hasCartItems(state),
    order,
    isNewOrder,
    cartItems,
    total,
    itemCount,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const orderId = get(ownProps, 'match.params.orderId', undefined)
  const isNewOrder = orderId === undefined || orderId === 'pay-now'
  const currentPath = ownProps?.match?.url ?? (() => {})
  const replace = ownProps?.history?.replace ?? (() => {})
  const push = ownProps?.history?.push ?? (() => {})

  return {
    onTopButtonTap: () => {
      if (isNewOrder) return

      dispatch(startTabOrderAdjustment(orderId, 'add', { calculateRemoteOrderTotal: true }))
      replace('/tabs')
    },
    onBottomButtonTap: () => {
      if (isNewOrder) {
        replace('/tab-order/pay-now')
      } else {
        replace(`/tab-order/${orderId}/pay-now`)
      }
    },
    onSelectItem: (index) => {
        push(`${currentPath}/cart/${index}`)
    },
    onRemove: (index) => dispatch(removeFromCart({ index })),
    onDiscount: () => replace('/tab-order/pay-now/select-discount'),
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TabsCartModal))
